import React, { useState, useEffect } from "react";
import Axios from "../../_services/caller.service";
import styles from "./UpComingCalibrations.module.scss";
import InputForms from "../UiComponents/forms/InputForms";

const UpcomingCalibrations = () => {
  const [calibrations, setCalibrations] = useState([]);
  const [error, setError] = useState(null);
  const [minDays, setMinDays] = useState(-360);
  const [maxDays, setMaxDays] = useState(30);
  const [selectedPeriod, setSelectedPeriod] = useState("1month");
  const [selectedTransducer, setSelectedTransducer] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(10);
  const [showDetails, setShowDetails] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const transducerNames = {
    Bone: "Conduction Osseuse",
    Inserts: "Inserts",
    Headphones: "Casque",
    Speakers: "Champ Libre",
  };

  const periodOptions = {
    "1week": 7,
    "2weeks": 14,
    "1month": 30,
    "3months": 90,
    "6months": 180,
  };

  useEffect(() => {
    fetchCalibrations();
  }, []);

  const fetchCalibrations = async () => {
    setError(null);
    try {
      const response = await Axios.get(
        `/getUpcomingCalibrations?minDays=${minDays}&maxDays=${maxDays}`
      );
      setCalibrations(response.data.data);
    } catch (err) {
      console.error("Erreur lors de la récupération des calibrations :", err.message);
      setError("Erreur lors du chargement des données.");
    }
  };

  const handleToggleDetails = () => {
    setShowDetails((prev) => !prev);
  };

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setSelectedPeriod(period);
    setMaxDays(periodOptions[period]);
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value.toLowerCase());
  const handleLoadMore = () => setVisibleCount((prev) => prev + 10);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedCalibrations = [...calibrations].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let valueA = a[sortConfig.key];
    let valueB = b[sortConfig.key];

    if (sortConfig.key === "Eoutpout") {
      valueA = transducerNames[a.Eoutpout] || a.Eoutpout;
      valueB = transducerNames[b.Eoutpout] || b.Eoutpout;
    }

    if (typeof valueA === "string") {
      return sortConfig.direction === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    } else {
      return sortConfig.direction === "asc" ? valueA - valueB : valueB - valueA;
    }
  });

  const filteredCalibrations = sortedCalibrations.filter(
    (calibration) =>
      (selectedTransducer === "All" || calibration.Eoutpout === selectedTransducer) &&
      [calibration.owner_login, calibration.cabname, transducerNames[calibration.Eoutpout] || ""]
        .some((field) => field?.toLowerCase().includes(searchTerm))
  );

  const visibleCalibrations = filteredCalibrations.slice(0, visibleCount);

  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? " ▲" : " ▼";
    }
    return "";
  };

  return (
    <>
      <button onClick={handleToggleDetails} className={styles.loadMoreButton}>
        {showDetails ? "Masquer les détails" : "Afficher les détails des centres"}
      </button>

      {showDetails && (
        <div className={styles.container}>
          <h1>Prochaines Calibrations</h1>
          <div className={styles.filters}>
            <label>
              Période
              <select
                value={selectedPeriod}
                onChange={handlePeriodChange}
                className={styles.select}
              >
                {Object.entries(periodOptions).map(([key, value]) => (
                  <option key={key} value={key}>
                    {key.replace("months", " mois").replace("month", " mois").replace("weeks", " semaines").replace("week", " semaine")}
                  </option>
                ))}
              </select>
            </label>
            <InputForms
              type="text"
              placeholder="Rechercher..."
              value={searchTerm}
              onChange={handleSearchChange}
              className={styles.searchInput}
            />
            <button type="button" onClick={fetchCalibrations} className={styles.fetchButton}>
              Filtrer
            </button>
          </div>

          {error && <p className={styles.error}>{error}</p>}

          <table className={styles.table}>
            <thead>
              <tr>
                <th onClick={() => handleSort("owner_login")}>
                  Nom du centre {getSortIndicator("owner_login")}
                </th>
                <th onClick={() => handleSort("cabname")}>
                  Nom de la cabine {getSortIndicator("cabname")}
                </th>
                <th onClick={() => handleSort("Eoutpout")}>
                  Type de Transducteur {getSortIndicator("Eoutpout")}
                </th>
                <th onClick={() => handleSort("numberOfDays")}>
                  Jours Restants {getSortIndicator("numberOfDays")}
                </th>
              </tr>
            </thead>
            <tbody>
              {visibleCalibrations.map((calibration) => (
                <tr key={`${calibration.cabid}-${calibration.Eoutpout}`}>
                  <td>{calibration.owner_login}</td>
                  <td>{calibration.cabname}</td>
                  <td>{transducerNames[calibration.Eoutpout] || calibration.Eoutpout}</td>
                  <td>{calibration.numberOfDays}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {visibleCount < filteredCalibrations.length && (
            <button type="button" onClick={handleLoadMore} className={styles.loadMoreButton}>
              Charger plus
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default UpcomingCalibrations;
